var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 173,
    viewBox: "0 0 175 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.374 146.6C148.908 151.205 144.912 153.908 141.851 155.953C112.017 175.876 77.911 170.13 67.3662 168.173C50.354 165.005 35.9953 162.772 23.6564 151.625C-4.3773 126.295 -3.01607 73.458 18.406 40.7258C20.9465 36.8429 42.3372 5.13948 76.5184 0.666881C77.3527 0.560242 77.98 0.497512 78.5258 0.434782C83.8138 -0.123509 116.577 -3.07806 143.294 19.3038C147.12 22.5092 153.274 28.2866 158.982 37.1001C179.846 69.3304 179.915 119.244 153.374 146.6Z",
    fill: "url(#paint0_linear_2120_9015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.223 11.9268H12.0451C5.52757 11.9268 0.358671 17.0706 0.502948 23.356L3.55787 156.875C3.6896 162.634 8.82713 167.257 15.0373 167.207L159.089 166.115C165.205 166.071 170.299 161.417 170.474 155.702L174.495 23.2557C174.677 17.0267 169.634 11.9268 163.223 11.9268Z",
    fill: "#CFE7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.495 23.626L131.933 23.6385C130.44 23.6385 129.06 24.4728 128.389 25.7839C125.008 32.3955 121.639 38.9821 118.29 45.5436C117.631 46.8358 116.263 47.6576 114.777 47.6639C96.786 47.6952 78.7639 47.7266 60.7041 47.758C59.2112 47.758 57.8374 46.9362 57.185 45.644C53.8604 39.0699 50.5232 32.4708 47.1672 25.8341C46.5022 24.523 45.1222 23.6824 43.6104 23.6824L24.8481 23.695C18.3619 23.7013 13.1992 28.7761 13.3184 35.0114L15.4261 146.03C15.539 151.826 20.6703 156.474 26.8931 156.43L147.452 155.577C153.594 155.533 158.694 150.847 158.85 145.089L161.78 34.8483C161.949 28.6569 156.893 23.6197 150.495 23.626Z",
    fill: "#F4F8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.208 25.0183C117.675 24.1652 116.715 23.6445 115.68 23.6445C97.1501 23.6571 78.5822 23.6634 59.983 23.6759C58.9416 23.6759 57.9693 24.1965 57.4236 25.0559C56.8779 25.9153 56.8339 26.988 57.3044 27.8913C59.5752 32.2384 61.8335 36.5668 64.0917 40.8888C64.7567 42.156 66.1116 42.9589 67.5857 42.9589C81.0663 42.9401 94.528 42.915 107.971 42.8962C109.439 42.8962 110.794 42.0932 111.465 40.8198C113.742 36.504 116.025 32.1757 118.315 27.8411C118.779 26.9441 118.742 25.8777 118.208 25.0183Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4934 33.2424C88.4934 33.5561 88.2236 33.9826 87.8974 33.9826H87.7469C87.4207 33.9826 87.1572 33.5624 87.1572 33.2424L87.176 26.9883C87.176 26.6747 87.4395 26.4175 87.7657 26.4175H87.9162C88.2424 26.4175 88.5059 26.6684 88.5059 26.9883L88.4934 33.2424Z",
    fill: "url(#paint1_linear_2120_9015)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6591 33.4301C80.8348 33.6936 80.7595 34.0449 80.4835 34.2205C80.2075 34.3899 79.8436 34.3209 79.668 34.0574L76.1238 28.8007C75.9481 28.5372 76.0234 28.1797 76.2994 28.0103C76.5754 27.8347 76.9393 27.9099 77.1149 28.1797L80.6591 33.4301Z",
    fill: "url(#paint2_linear_2120_9015)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2296 37.1564C74.4868 37.3508 74.5307 37.7084 74.33 37.953C74.1292 38.2039 73.7591 38.2479 73.5019 38.0534L68.3707 34.2081C68.1135 34.0136 68.0633 33.6561 68.264 33.4052C68.4648 33.1542 68.8349 33.1103 69.0921 33.3048L74.2296 37.1564Z",
    fill: "url(#paint3_linear_2120_9015)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8111 33.4115C94.6292 33.6749 94.7044 34.0262 94.9804 34.2019C95.2502 34.3712 95.6203 34.2959 95.7959 34.0325L99.3715 28.7695C99.5534 28.506 99.4781 28.1485 99.2021 27.9791C98.9324 27.8097 98.5623 27.885 98.3866 28.1485L94.8111 33.4115Z",
    fill: "url(#paint4_linear_2120_9015)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.197 37.1188C100.94 37.3132 100.889 37.6708 101.09 37.9154C101.291 38.1601 101.655 38.204 101.912 38.0158L107.056 34.1642C107.313 33.9698 107.363 33.6122 107.169 33.3676C106.974 33.1166 106.604 33.0727 106.341 33.2672L101.197 37.1188Z",
    fill: "url(#paint5_linear_2120_9015)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2120_9015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 23,
    width: 63,
    height: 20
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.208 25.0183C117.675 24.1652 116.715 23.6445 115.68 23.6445C97.1501 23.6571 78.5822 23.6634 59.983 23.6759C58.9416 23.6759 57.9693 24.1965 57.4236 25.0559C56.8779 25.9153 56.8339 26.988 57.3044 27.8913C59.5752 32.2384 61.8335 36.5668 64.0917 40.8888C64.7567 42.156 66.1116 42.9589 67.5857 42.9589C81.0663 42.9401 94.528 42.915 107.971 42.8962C109.439 42.8962 110.794 42.0932 111.465 40.8198C113.742 36.504 116.025 32.1757 118.315 27.8411C118.779 26.9441 118.742 25.8777 118.208 25.0183Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2120_9015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.7509 50.6183C88.7509 51.1013 88.3369 51.4588 87.835 51.4588H87.6719C87.1701 51.4588 86.7624 51.1013 86.7686 50.6183L86.8188 36.5857C86.8188 36.0964 87.2328 35.8706 87.7347 35.8706H87.8978C88.3996 35.8706 88.8073 36.0964 88.8073 36.5857L88.7509 50.6183Z",
    fill: "url(#paint6_linear_2120_9015)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22518 71.6387C8.04326 71.6387 7.89271 71.5007 7.88644 71.3251L6.95804 26.8939C6.84513 21.38 11.5561 16.8823 17.4589 16.8823H26.2536C26.4418 16.8823 26.5923 17.0266 26.5923 17.2085C26.5923 17.3904 26.448 17.5347 26.2599 17.5347H17.4652C11.9325 17.5347 7.51634 21.7438 7.62298 26.8939L8.5451 71.3251C8.55137 71.4945 8.40709 71.6387 8.22518 71.6387Z",
    fill: "url(#paint7_linear_2120_9015)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.154 152.779C164.979 152.779 164.841 152.647 164.847 152.484L165.813 118.579C165.819 118.409 165.963 118.278 166.145 118.271C166.321 118.271 166.465 118.403 166.459 118.573L165.48 152.478C165.48 152.647 165.33 152.779 165.154 152.779Z",
    fill: "url(#paint8_linear_2120_9015)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.682 163.907L161.454 163.468C159.24 160.871 157.019 158.393 154.805 155.79C154.278 155.175 153.507 154.937 152.697 154.937C137.755 154.937 122.813 154.937 107.871 154.937C107.062 154.937 106.29 155.169 105.763 155.79C103.549 158.387 101.328 160.928 99.114 163.525L94.8672 163.932L94.8797 169.616C94.8985 169.961 94.9738 170.368 95.1244 170.695C95.576 171.673 96.5609 172.363 97.6398 172.363C119.407 172.363 141.174 172.363 162.935 172.363C164.014 172.363 164.999 171.667 165.45 170.688C165.601 170.362 165.676 169.98 165.695 169.634L165.682 163.907Z",
    fill: "#CFE7FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.036 162.408C161.623 158.406 158.211 154.642 154.798 150.64C154.271 150.025 153.5 149.9 152.69 149.9C137.748 149.9 122.806 149.9 107.864 149.9C107.055 149.9 106.283 150.019 105.756 150.64C102.344 154.642 98.9314 158.525 95.5189 162.521C94.8164 163.343 94.6595 164.516 95.1112 165.494C95.5628 166.473 96.5477 167.119 97.6266 167.119C119.394 167.119 141.161 167.119 162.922 167.119C164 167.119 164.985 166.417 165.437 165.438C165.895 164.459 165.738 163.23 165.036 162.408Z",
    fill: "#9DC7C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.894 165.444C125.862 165.444 124.275 164.572 123.535 163.625C122.857 162.759 122.97 161.567 123.842 160.513C124.313 159.918 125.291 159.14 126.364 159.14H134.186C135.259 159.14 136.237 159.748 136.708 160.35C137.586 161.404 137.693 162.772 137.015 163.637C136.275 164.585 134.688 165.444 132.656 165.444H127.894Z",
    fill: "#CFE7FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M134.186 160.193C131.577 160.193 128.973 160.193 126.364 160.193C125.925 160.193 125.304 160.739 124.977 161.159C123.572 162.834 124.877 164.396 127.888 164.396C129.475 164.396 131.062 164.396 132.655 164.396C135.673 164.396 136.978 162.841 135.566 161.159C135.246 160.733 134.625 160.193 134.186 160.193Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.838 160.457L130.152 163.06C130.158 163.085 130.177 163.104 130.202 163.104C130.227 163.104 130.253 163.085 130.253 163.06L130.71 160.143C130.71 160.143 129.744 159.711 129.838 160.457Z",
    fill: "url(#paint9_linear_2120_9015)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.789 161.63C138.098 161.543 136.705 161.204 135.984 160.89C135.984 161.172 135.984 161.467 135.99 161.762C135.996 162.082 136.22 162.339 136.498 162.339L151.285 162.276C151.757 162.276 152.035 161.693 151.828 161.235C149.892 161.398 144.951 161.768 140.789 161.63Z",
    fill: "url(#paint10_linear_2120_9015)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.628 155.646C136.97 154.366 138.08 153.507 139.332 153.551L140.565 153.595C147.135 155.289 150.453 159.159 151.751 161.104C151.775 161.141 151.793 161.185 151.81 161.223C149.868 161.386 144.933 161.756 140.766 161.618C138.074 161.53 136.681 161.191 135.961 160.878C135.979 158.638 136.291 156.888 136.628 155.646Z",
    fill: "url(#paint11_linear_2120_9015)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M136.539 147.171L137.354 154.611C137.342 155.383 137.85 156.004 138.487 156.06L141.208 156.292C141.846 156.349 143.091 155.91 143.103 155.138L145.098 147.165H136.539V147.171Z",
    fill: "url(#paint12_linear_2120_9015)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.461 161.63C123.322 161.543 124.802 161.204 125.567 160.89C125.567 161.172 125.567 161.467 125.561 161.762C125.555 162.082 125.316 162.339 125.022 162.339L109.308 162.276C108.806 162.276 108.511 161.693 108.731 161.235C110.788 161.398 116.033 161.768 120.461 161.63Z",
    fill: "url(#paint13_linear_2120_9015)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M124.884 155.646C124.52 154.366 123.341 153.507 122.011 153.551L120.7 153.595C113.718 155.289 110.193 159.159 108.813 161.104C108.788 161.141 108.769 161.185 108.75 161.223C110.814 161.386 116.058 161.756 120.487 161.618C123.347 161.53 124.828 161.191 125.593 160.878C125.568 158.638 125.235 156.888 124.884 155.646Z",
    fill: "url(#paint14_linear_2120_9015)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.971 147.171L124.105 154.611C124.118 155.383 123.578 156.004 122.901 156.06L120.009 156.292C119.331 156.349 118.008 155.91 117.995 155.138L115.875 147.165H124.971V147.171Z",
    fill: "url(#paint15_linear_2120_9015)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.698 91.9941L130.629 92.0817L106.522 91.9941C106.522 91.9941 104.219 110.584 111.271 123.527C113.544 132.156 114.894 143.643 115.803 146.425C116.712 149.202 117.152 151.784 117.152 151.784H124.659L127.807 121.095C127.961 119.626 128.949 118.5 130.115 118.5H131.138C132.265 118.5 133.219 119.513 133.362 120.926L137.301 151.922L144.028 151.653C144.028 151.653 144.477 149.139 145.387 146.363C146.296 143.587 147.655 132.169 149.928 123.534C156.981 110.59 154.698 91.9941 154.698 91.9941Z",
    fill: "#536288"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M152.823 90.7545C146.181 95.0722 143.248 99.0165 132.61 99.4889V99.5054C132.261 99.5219 131.709 99.8789 131.198 99.8789H130.25C129.745 99.8789 128.948 99.5219 128.25 99.5054V99.4889C117.961 99.0165 114.971 95.0777 108.329 90.7545C100.895 85.9203 105.078 74.582 106.755 68.7865C108.438 62.9855 107.771 55.0531 109.933 46.5933C111.381 40.9076 116.804 38.3477 120.185 37.282C120.732 37.1062 121.233 37.0733 121.649 36.9744C122.493 36.7711 123.025 36.7986 123.025 36.7986H138.414C138.414 36.7986 138.934 36.7766 139.778 36.9744C140.19 37.0788 140.685 37.1612 141.232 37.3315C144.613 38.3972 150.01 40.9296 151.458 46.6207C153.615 55.0805 152.859 63.002 154.542 68.803C156.225 74.593 160.257 85.9203 152.823 90.7545Z",
    fill: "#FEF7D8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.419 36.6986C140.258 42.6893 135.817 47.0615 130.51 47.0615C125.197 47.0615 120.75 42.7332 119.602 36.73C120.618 36.4979 121.245 36.4979 121.245 36.4979H139.775C139.775 36.4979 140.403 36.4728 141.419 36.6986Z",
    fill: "url(#paint16_linear_2120_9015)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M121.998 30.1061C121.998 30.1061 118.886 27.829 119.168 32.7721C119.451 37.7152 121.483 36.768 121.483 36.768L121.998 30.1061Z",
    fill: "url(#paint17_linear_2120_9015)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138.633 30.1061C138.633 30.1061 141.744 27.829 141.456 32.7721C141.173 37.7152 139.141 36.768 139.141 36.768L138.633 30.1061Z",
    fill: "url(#paint18_linear_2120_9015)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.227 25.9255C119.977 30.901 118.217 39.6303 122.828 43.4605C125.785 45.9165 130.217 46.1519 133.809 45.2548C142.945 42.9833 139.26 29.1004 137.997 22.5534C137.997 22.5597 124.118 17.4379 121.227 25.9255Z",
    fill: "url(#paint19_linear_2120_9015)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.458 29.8049C121.458 29.8049 121.998 22.3464 125.316 24.2973C128.634 26.2481 129.5 27.7536 132.386 26.888C135.271 26.0286 136.269 22.3338 137.58 25.0186C138.891 27.7035 139.681 31.9126 139.681 31.9126C139.681 31.9126 140.61 26.75 140.396 24.5858C140.177 22.4217 140.321 16.5753 135.56 17.0834C135.56 17.0834 131.3 19.5361 126.972 19.1786C121.527 18.7144 119.564 25.809 121.458 29.8049Z",
    fill: "url(#paint20_linear_2120_9015)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.994 93.2221C119.38 93.291 119.709 93.2221 118.994 91.1302C118.278 89.0382 114.438 90.1907 114.438 90.1907C114.438 90.1907 106.261 72.6032 109.228 66.9161C112.191 61.229 118.665 51.7713 114.438 39.4263C114.438 39.4263 101.653 46.9673 99.5109 56.6943C97.3832 66.3586 96.0713 87.1279 112.697 96.93C112.697 96.93 112.697 96.93 112.697 96.9363C114.362 99.7799 117.343 99.7861 119.977 98.6337C122.615 97.4749 118.607 93.1532 118.994 93.2221Z",
    fill: "url(#paint21_linear_2120_9015)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.651 93.2221C141.274 93.291 140.952 93.2221 141.651 91.1302C142.35 89.0382 146.1 90.1907 146.1 90.1907C146.1 90.1907 154.086 72.6032 151.188 66.9161C148.295 61.229 141.972 51.7713 146.1 39.4263C146.1 39.4263 158.587 46.9673 160.679 56.6943C162.756 66.3586 164.038 87.1279 147.801 96.93C147.801 96.93 147.801 96.93 147.801 96.9363C146.175 99.7799 143.263 99.7861 140.691 98.6337C138.11 97.4749 142.024 93.1532 141.651 93.2221Z",
    fill: "url(#paint22_linear_2120_9015)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M145.088 75.5971C145.05 75.5971 145.006 75.5845 144.969 75.5657C132.36 67.4924 116.452 73.2196 116.295 73.2761C116.182 73.32 116.057 73.2635 116.019 73.1506C115.975 73.0377 116.038 72.9123 116.145 72.8746C116.308 72.8119 132.416 67.0157 145.201 75.2019C145.301 75.2646 145.332 75.4026 145.263 75.503C145.226 75.5657 145.157 75.5971 145.088 75.5971Z",
    fill: "url(#paint23_linear_2120_9015)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2120_9015",
    x1: 189.696,
    y1: 198.262,
    x2: 68.7309,
    y2: 69.4933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2120_9015",
    x1: 87.1643,
    y1: 30.1998,
    x2: 88.5174,
    y2: 30.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2120_9015",
    x1: 77.8611,
    y1: 31.4552,
    x2: 78.9238,
    y2: 30.7628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2120_9015",
    x1: 70.9131,
    y1: 36.184,
    x2: 71.6958,
    y2: 35.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2120_9015",
    x1: 97.6304,
    y1: 31.4439,
    x2: 96.5505,
    y2: 30.7403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2120_9015",
    x1: 104.515,
    y1: 36.1445,
    x2: 103.735,
    y2: 35.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2120_9015",
    x1: 105.031,
    y1: 28.8814,
    x2: 56.5807,
    y2: 70.3196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2120_9015",
    x1: 6.95704,
    y1: 44.2581,
    x2: 26.5971,
    y2: 44.2581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2120_9015",
    x1: 164.848,
    y1: 135.526,
    x2: 166.459,
    y2: 135.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2120_9015",
    x1: 127.277,
    y1: 159.041,
    x2: 132.739,
    y2: 163.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2120_9015",
    x1: 153.912,
    y1: 153.13,
    x2: 111.962,
    y2: 183.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2120_9015",
    x1: 150.191,
    y1: 161.409,
    x2: 114.371,
    y2: 150.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2120_9015",
    x1: 136.542,
    y1: 151.738,
    x2: 145.098,
    y2: 151.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2120_9015",
    x1: 106.511,
    y1: 153.13,
    x2: 149.156,
    y2: 186.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2120_9015",
    x1: 110.466,
    y1: 161.409,
    x2: 148.097,
    y2: 148.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2120_9015",
    x1: 124.969,
    y1: 151.738,
    x2: 115.876,
    y2: 151.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2120_9015",
    x1: 124.763,
    y1: 55.8336,
    x2: 130.922,
    y2: 35.4903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2120_9015",
    x1: 118.153,
    y1: 41.166,
    x2: 121.31,
    y2: 30.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2120_9015",
    x1: 142.476,
    y1: 41.166,
    x2: 139.319,
    y2: 30.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2120_9015",
    x1: 128.346,
    y1: 45.6025,
    x2: 132.514,
    y2: 13.3869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2120_9015",
    x1: 129.966,
    y1: 30.9183,
    x2: 132.529,
    y2: 11.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2120_9015",
    x1: 105.825,
    y1: 48.3481,
    x2: 78.7678,
    y2: -82.7236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2120_9015",
    x1: 160.533,
    y1: 48.2101,
    x2: 254.541,
    y2: -40.9644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2120_9015",
    x1: 133.917,
    y1: 61.7872,
    x2: 123.526,
    y2: 101.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#233894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#DD397A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.83bd694095e70f7982a3802944fbb01f.svg";
export { ForwardRef as ReactComponent };